<template>
	<core-page class="om-app-404">
		<h1 class="omapi-warning">404</h1>
		<strong>Uh oh!</strong> We can't find what you're looking for!
	</core-page>
</template>

<script lang="js">
export default {
	name: 'NotFound404',
};
</script>

<style lang="scss">
.omapi-screen {
	.om-app-404 {
		h1.omapi-warning {
			&:before {
				padding-right: 5px;
			}
		}
		.omapi-box {
			margin-right: 0;
			margin-left: 0;
		}
	}
}
</style>
